import { CatalogHierarchyApi } from './catalogHierarchyApi';

/**
 * Cache simples em memória para evitar re-fetches desnecessários.
 * Chave: string identificadora, Valor: dados retornados.
 */
const cache = {};

function getCacheKey(prefix, id) {
  return id ? `${prefix}_${id}` : prefix;
}

/**
 * Serviço compartilhado de catálogo hierárquico.
 * Implementa cache leve em memória e tratamento de erros consistente.
 */
export const CatalogHierarchyService = {

  /**
   * Busca todas as categorias (com cache).
   * @returns {Promise<Array<{id: number, nome: string}>>}
   */
  getCategorias: async () => {
    const key = getCacheKey('categorias');
    if (cache[key]) return cache[key];

    try {
      const response = await CatalogHierarchyApi.getCategorias();
      const data = response.data || [];
      cache[key] = data;
      return data;
    } catch (error) {
      console.error('Erro ao carregar categorias:', error);
      throw new Error(error.response?.data?.error || 'Erro ao carregar categorias');
    }
  },

  /**
   * Busca produtos por categoria (com cache).
   * @param {number} categoriaId
   * @returns {Promise<Array<{id: number, nome: string}>>}
   */
  getProdutosByCategoria: async (categoriaId) => {
    if (!categoriaId) return [];

    const key = getCacheKey('produtos', categoriaId);
    if (cache[key]) return cache[key];

    try {
      const response = await CatalogHierarchyApi.getProdutosByCategoria(categoriaId);
      const data = response.data || [];
      cache[key] = data;
      return data;
    } catch (error) {
      console.error('Erro ao carregar produtos:', error);
      throw new Error(error.response?.data?.error || 'Erro ao carregar produtos');
    }
  },

  /**
   * Busca serviços por produto (com cache).
   * @param {number} produtoId
   * @returns {Promise<Array<{id: number, nome: string}>>}
   */
  getServicosByProduto: async (produtoId) => {
    if (!produtoId) return [];

    const key = getCacheKey('servicos', produtoId);
    if (cache[key]) return cache[key];

    try {
      const response = await CatalogHierarchyApi.getServicosByProduto(produtoId);
      const data = response.data || [];
      cache[key] = data;
      return data;
    } catch (error) {
      console.error('Erro ao carregar serviços:', error);
      throw new Error(error.response?.data?.error || 'Erro ao carregar serviços');
    }
  },

  /**
   * Limpa o cache de catálogo (útil após mudanças de contexto).
   */
  clearCache: () => {
    Object.keys(cache).forEach(key => delete cache[key]);
  },
};
